import { memo, useMemo } from 'react'
import { useIntl } from 'react-intl'
import type { CellValue, IdType } from 'react-table'
import type { State } from '@racepointenergy/swc/scs/features/host-states'

import { messages } from '../messages'
import theme from 'theme_'
import { getGlyph } from './loadIcon'
import { Body12, BodyPrimary } from 'components/Typography/Labels'
import {
  MobileTableBlock,
  MobileTableBlockCell,
  MobileTableBlockRow,
} from 'components/Table/MobileBlock/styles'
import { formatPower } from '../utils'
import { OnState, LoadCellWrapper } from './styles'

interface LoadStatusBlockProps {
  values: Record<IdType<State>, CellValue>
  original: Record<IdType<State>, CellValue>
}

export function LoadStatusBlock({ values, original }: LoadStatusBlockProps) {
  const { formatMessage } = useIntl()

  const glyph = useMemo(() => getGlyph(original.image), [original.image])

  const state = useMemo(() => {
    if (values.State === -1) {
      return '-'
    }
    return values.State === 1 ? (
      <OnState>{formatMessage(messages.stateOn)}</OnState>
    ) : (
      formatMessage(messages.stateOff)
    )
  }, [values.State, formatMessage])

  return (
    <MobileTableBlock>
      <MobileTableBlockRow>
        <BodyPrimary bold color={theme.colors.otterWarmBlack}>
          <LoadCellWrapper>
            {glyph} {values.Load}
          </LoadCellWrapper>
        </BodyPrimary>
      </MobileTableBlockRow>
      <MobileTableBlockRow>
        <MobileTableBlockCell>
          <Body12 color={theme.colors.darkeyGrey}>
            {formatMessage(messages.headerConsuming)}
          </Body12>
        </MobileTableBlockCell>
        <MobileTableBlockCell>
          <BodyPrimary color={theme.colors.otterWarmBlack}>
            {formatPower(values.Consuming)}
          </BodyPrimary>
        </MobileTableBlockCell>
      </MobileTableBlockRow>
      <MobileTableBlockRow>
        <MobileTableBlockCell>
          <Body12 color={theme.colors.darkeyGrey}>
            {formatMessage(messages.headerState)}
          </Body12>
        </MobileTableBlockCell>
        <MobileTableBlockCell>
          <BodyPrimary color={theme.colors.otterWarmBlack}>{state}</BodyPrimary>
        </MobileTableBlockCell>
      </MobileTableBlockRow>
      <MobileTableBlockRow>
        <MobileTableBlockCell>
          <Body12 color={theme.colors.darkeyGrey}>
            {formatMessage(messages.headerStatus)}
          </Body12>
        </MobileTableBlockCell>
        <MobileTableBlockCell>
          <BodyPrimary color={theme.colors.otterWarmBlack}>
            {values.Status}
          </BodyPrimary>
        </MobileTableBlockCell>
      </MobileTableBlockRow>
    </MobileTableBlock>
  )
}

export default memo(LoadStatusBlock)
